import { render, staticRenderFns } from "./modalVerProducto.vue?vue&type=template&id=1a279aba&scoped=true&"
import script from "./modalVerProducto.vue?vue&type=script&lang=js&"
export * from "./modalVerProducto.vue?vue&type=script&lang=js&"
import style0 from "./modalVerProducto.vue?vue&type=style&index=0&id=1a279aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a279aba",
  null
  
)

export default component.exports